import React from "react";
import { StaticQuery, graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { variablesSubstitution } from "./Variables-en";

const Metiers = (props) => (
  <StaticQuery
    query={graphql`
      {
        allMarkdownRemark(
          sort: { fields: frontmatter___poids, order: ASC }
          filter: { frontmatter: { type: { eq: "metier-en" } } }
        ) {
          totalCount
          edges {
            node {
              fields {
                slug
              }
              id
              frontmatter {
                shortTitle
                excerpt
                imageAlt
                image {
                  childImageSharp {
                    gatsbyImageData(
                      width: 600
                      placeholder: BLURRED
                      layout: CONSTRAINED
                    )
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={(data) => (
      <div>
        <BlockTitle>Services</BlockTitle>
        <Hr />
        {data.allMarkdownRemark.edges
          .filter((page) => page.node.fields.slug !== props.currentSlug)
          .map(({ node }) => (
            <div
              key={node.id}
              css={css`
                position: relative;
              `}
            >
              <Link
                to={node.fields.slug}
                css={css`
                  padding-right: 10px;
                  .gatsby-image-wrapper img {
                    margin-top: 3px;
                    transform: scale(1) !important;
                    transition: all 0.35s ease-in-out !important;
                  }
                  p {
                    opacity: 0;
                    transition: all 0.5s ease-in-out !important;
                  }
                  :hover .gatsby-image-wrapper img {
                    transform: scale(1.04) !important;
                    transition: all 0.53s ease-in-out !important;
                    opacity: 0.2 !important;
                  }
                  :hover p {
                    opacity: 1;
                    transition: all 0.5s ease-in-out !important;
                  }
                `}
              >
                <GatsbyImage
                  image={node.frontmatter.image.childImageSharp.gatsbyImageData}
                  alt={variablesSubstitution(node.frontmatter.imageAlt)}
                />
                <Title>{node.frontmatter.shortTitle}</Title>
                <P>{variablesSubstitution(node.frontmatter.excerpt)}</P>
              </Link>
            </div>
          ))}
      </div>
    )}
  />
);

export default Metiers;

const BlockTitle = styled.div`
  font-family: "Raleway", sans-serif;
  color: #7a9282;
  text-align: center;
  font-weight: 700;
  font-size: 26px;
  letter-spacing: 0.04em;
  line-height: 28px;
  padding-bottom: 8px;
  margin: 1em 0 0em;
`;

const Hr = styled.hr`
  width: 33%;
  margin: 0 auto;
  background-color: #7a9282;
  height: 3px;
  border: 0;
  margin-bottom: 20px;
`;

const Title = styled.div`
  color: #7a9282;
  margin: 0.4em 0 0.2em;
  text-align: center;
  font-size: 1em;
  letter-spacing: 0.08em;
  font-weight: 700;
  letter-spacing: 0.02em;
  z-index: 3;
`;

const P = styled.p`
  position: absolute;
  top: 0;
  color: #333;
  font-weight: 500;
  font-size: 0.9em;
  line-height: 1.2em;
  margin-top: 0;
  padding: 1em 1.25em 1em 2em;
  z-index: 2;
  :before {
    content: "“";
    display: block;
    margin-left: -15px;
    margin-top: 5px;
    font-size: 3em;
    color: #7a9282;
  }
`;
